import React, { useState, useEffect } from 'react';
import api from '../../http';

const CreateEventWizard = ({ onComplete, onCancel }) => {
  const [name, setName] = useState('');
  const [eventDate, setEventDate] = useState('');
  const [location, setLocation] = useState('');

  // Optional station templates to include immediately
  const [templates, setTemplates] = useState([]);
  const [selectedTemplateIds, setSelectedTemplateIds] = useState([]);

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    // Fetch templates just in case they want to quickly prepopulate stations
    api
      .get('/api/admin/station-templates')
      .then((res) => setTemplates(res.data))
      .catch((err) => console.error('Failed to load templates:', err));
  }, []);

  const toggleTemplate = (id) => {
    if (selectedTemplateIds.includes(id)) {
      setSelectedTemplateIds(selectedTemplateIds.filter((tid) => tid !== id));
    } else {
      setSelectedTemplateIds([...selectedTemplateIds, id]);
    }
  };

  const handleSubmit = async () => {
    if (!name || !eventDate) {
      setError('Name and Event Date are required.');
      return;
    }
    setSubmitting(true);
    setError('');

    try {
      // Build stations payload
      const stations = selectedTemplateIds.map((templateId, index) => ({
        templateId,
        stationNumber: index + 1
      }));

      const payload = {
        name,
        event_date: eventDate,
        location,
        stations
      };

      await api.post('/api/test-events/wizard', payload);

      if (onComplete) onComplete();
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || 'Failed to create event. Please try again.');
      setSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="wizard-modal">
        <h2 style={{ marginTop: 0, marginBottom: '1.5rem' }}>Create New Test Event</h2>

        {error && (
          <div
            className="alert danger"
            style={{
              marginBottom: '1rem',
              padding: '0.75rem',
              backgroundColor: '#fed7d7',
              color: '#9b2c2c',
              borderRadius: '4px'
            }}
          >
            {error}
          </div>
        )}

        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}>
            Event Name *
          </label>
          <input
            type="text"
            className="input"
            style={{
              width: '100%',
              padding: '0.75rem',
              border: '1px solid #cbd5e0',
              borderRadius: '4px'
            }}
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Spring 2026 Certification"
            autoFocus
          />
        </div>

        <div className="form-group" style={{ marginBottom: '1rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}>
            Event Date *
          </label>
          <input
            type="date"
            className="input"
            style={{
              width: '100%',
              padding: '0.75rem',
              border: '1px solid #cbd5e0',
              borderRadius: '4px'
            }}
            value={eventDate}
            onChange={(e) => setEventDate(e.target.value)}
          />
        </div>

        <div className="form-group" style={{ marginBottom: '1.5rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}>
            Location
          </label>
          <input
            type="text"
            className="input"
            style={{
              width: '100%',
              padding: '0.75rem',
              border: '1px solid #cbd5e0',
              borderRadius: '4px'
            }}
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            placeholder="Training Center"
          />
        </div>

        <div className="form-group" style={{ marginBottom: '2rem' }}>
          <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 600 }}>
            Pre-populate Stations from Templates (Optional)
          </label>
          <div
            style={{
              border: '1px solid #e2e8f0',
              borderRadius: '4px',
              maxHeight: '150px',
              overflowY: 'auto'
            }}
          >
            {templates.length === 0 && (
              <div style={{ padding: '0.75rem', color: '#666' }}>No templates available.</div>
            )}
            {templates.map((t) => (
              <div key={t.id} style={{ padding: '0.75rem', borderBottom: '1px solid #edf2f7' }}>
                <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                  <input
                    type="checkbox"
                    checked={selectedTemplateIds.includes(t.id)}
                    onChange={() => toggleTemplate(t.id)}
                    style={{ marginRight: '0.75rem', transform: 'scale(1.2)' }}
                  />
                  {t.name}
                </label>
              </div>
            ))}
          </div>
        </div>

        <div
          style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem', marginTop: '1rem' }}
        >
          <button className="btn btn-secondary" onClick={onCancel} disabled={submitting}>
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={submitting || !name || !eventDate}
          >
            {submitting ? 'Creating...' : 'Create Event'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateEventWizard;
